import { handleActions } from 'redux-actions';
import { createSelector } from '@reduxjs/toolkit';
import {
  ACCEPT_APPLICATION,
  ANNULMENT_APPLICATION,
  ASSIGN_APPLICATION_BY_ID,
  CREATE_APPLICATION,
  DELETE_DOCUMENT,
  DENIED_APPLICATION,
  EDIT_APPLICATION_BY_ID, GENERATE_DOCX,
  LOAD_APPLICATION_BY_ID,
  LOAD_APPLICATION_HISTORY,
  LOAD_APPLICATION_STATUS,
  LOAD_AWAIT_DOCUMENT,
  LOAD_DOCUMENT_BY_ID,
  LOAD_LIST,
  LOAD_SMEV_CHECK_LIST,
  RETURN_APPLICATION,
  REVIEW_APPLICATION,
  SMEV_CHECK_ALL_APPLICATION,
  SUSPENDED_APPLICATION,
  APPLICATION_FIELDS_VALIDATION,
  LOAD_LEGAL_ENTITY_FORM_LIST,
  SEARCH_INFO_BY_PARAM, LOAD_LIST_ID, EXPORT_APPLICATION,
  ACCEPT_APPLICANT,
  LOAD_PREVIEW_DOCUMENT,
  REGISTER_MAIS_EGU, MAIS_EGU_HISTORY,
} from './actions';
import { APPLICATION_MODULE } from '../../configs/moduleNames';
import {
  createLoadListReducer,
  createLoadListReducerWithBegin, createLoadParameterReducer,
  createOperationStateReducer, updateLoadParameterReducer,
} from '../../utils/getCrudConfig';
import { FAILED, SUCCESSFUL, CLEAR } from '../../configs/actionNames';

const initialState = {
  listMeta: {},
  loadingList: false,
  list: [],
  loadingCurrentApplication: false,
  currentApplication: {},
  loadingCreateApplication: false,
  loadingEditApplicationById: false,
  loadingApplicationStatus: false,
  applicationStatus: {},
  loadingSmevCheckList: false,
  smevCheckList: [],
  loadingApplicationHistory: false,
  applicationHistory: [],
  loadingAcceptApplication: false,
  loadingReturnApplication: false,
  loadingDeniedApplication: false,
  loadingSuspendedApplication: false,
  loadingAnnulmentApplication: false,
  loadingSmevCheckApplication: false,
  loadingDeleteDocument: false,
  awaitDocumentMeta: {},
  loadingAwaitDocument: false,
  awaitDocument: [],
  loadingDocument: false,
  currentDocument: null,
  loadingReviewApplication: false,
  loadingGenerateDocx: false,
  loadingFieldsValidation: false,
  fieldsValidation: {},
  loadingLegalEntityFormList: false,
  legalEntityFormList: [],
  infoList: [],
  searchInfoType: null,
  startInfoSearch: false,
  loadingInfoList: false,
  loadingIdList: false,
  listId: [],
  loadingExportApplication: false,
  loadingAcceptApplicant: false,
  loadingPreviewDocument: false,
  loadingRegisterMaisEgu: false,
  maisEguHistoryList: [],
  loadingMaisEguHistory: false,
};

const reducer = handleActions({
  ...createLoadListReducerWithBegin(APPLICATION_MODULE + LOAD_LEGAL_ENTITY_FORM_LIST, 'legalEntityFormList', 'loadingLegalEntityFormList'),
  ...createLoadListReducerWithBegin(APPLICATION_MODULE + LOAD_LIST, 'list', 'loadingList'),
  ...createLoadListReducerWithBegin(APPLICATION_MODULE + LOAD_LIST_ID, 'listId', 'loadingIdList'),
  ...updateLoadParameterReducer(APPLICATION_MODULE + LOAD_APPLICATION_BY_ID, 'currentApplication', 'loadingCurrentApplication', {}),
  ...createOperationStateReducer(APPLICATION_MODULE + CREATE_APPLICATION, 'loadingCreateApplication'),
  ...createOperationStateReducer(APPLICATION_MODULE + EDIT_APPLICATION_BY_ID, 'loadingEditApplicationById'),
  ...updateLoadParameterReducer(APPLICATION_MODULE + LOAD_APPLICATION_STATUS, 'applicationStatus', 'loadingApplicationStatus', {}),
  ...createLoadListReducer(APPLICATION_MODULE + LOAD_SMEV_CHECK_LIST, 'smevCheckList', 'loadingSmevCheckList'),
  ...createLoadListReducer(APPLICATION_MODULE + LOAD_APPLICATION_HISTORY, 'applicationHistory', 'loadingApplicationHistory'),
  ...createOperationStateReducer(APPLICATION_MODULE + ACCEPT_APPLICATION, 'loadingAcceptApplication'),
  ...createOperationStateReducer(APPLICATION_MODULE + RETURN_APPLICATION, 'loadingReturnApplication'),
  ...createOperationStateReducer(APPLICATION_MODULE + DENIED_APPLICATION, 'loadingDeniedApplication'),
  ...createOperationStateReducer(APPLICATION_MODULE + SUSPENDED_APPLICATION, 'loadingSuspendedApplication'),
  ...createOperationStateReducer(APPLICATION_MODULE + ANNULMENT_APPLICATION, 'loadingAnnulmentApplication'),
  ...createOperationStateReducer(APPLICATION_MODULE + SMEV_CHECK_ALL_APPLICATION, 'loadingSmevCheckApplication'),
  ...createLoadListReducerWithBegin(APPLICATION_MODULE + LOAD_AWAIT_DOCUMENT, 'awaitDocument', 'loadingAwaitDocument'),
  ...createLoadParameterReducer(APPLICATION_MODULE + LOAD_DOCUMENT_BY_ID, 'currentDocument', 'loadingDocument'),
  ...createOperationStateReducer(APPLICATION_MODULE + DELETE_DOCUMENT, 'loadingDeleteDocument'),
  ...createOperationStateReducer(APPLICATION_MODULE + REVIEW_APPLICATION, 'loadingReviewApplication'),
  ...createOperationStateReducer(APPLICATION_MODULE + GENERATE_DOCX, 'loadingGenerateDocx'),
  ...createOperationStateReducer(APPLICATION_MODULE + EXPORT_APPLICATION, 'loadingExportApplication'),
  // ...createLoadByIdReducer(APPLICATION_MODULE + ASSIGN_APPLICATION_BY_ID, 'currentApplication', 'loadingCurrentApplication'),
  ...updateLoadParameterReducer(APPLICATION_MODULE + APPLICATION_FIELDS_VALIDATION, 'fieldsValidation', 'loadingFieldsValidation', {}),
  ...createOperationStateReducer(APPLICATION_MODULE + ACCEPT_APPLICANT, 'loadingAcceptApplicant'),
  ...createOperationStateReducer(APPLICATION_MODULE + LOAD_PREVIEW_DOCUMENT, 'loadingPreviewDocument'),
  ...createOperationStateReducer(APPLICATION_MODULE + REGISTER_MAIS_EGU, 'loadingRegisterMaisEgu'),
  ...createLoadListReducerWithBegin(APPLICATION_MODULE + MAIS_EGU_HISTORY, 'maisEguHistoryList', 'loadingMaisEguHistory'),
  [APPLICATION_MODULE + ASSIGN_APPLICATION_BY_ID]: state => ({
    ...state,
    loadingCurrentApplication: true,
  }),
  [APPLICATION_MODULE + ASSIGN_APPLICATION_BY_ID + SUCCESSFUL]: (state, action) => {
    const data = action.payload;
    return {
      ...state,
      loadingCurrentApplication: false,
      currentApplication: data,
    };
  },
  [APPLICATION_MODULE + ASSIGN_APPLICATION_BY_ID + FAILED]: state => ({
    ...state,
    loadingCurrentApplication: false,
  }),
  [APPLICATION_MODULE + SEARCH_INFO_BY_PARAM]: (state, action) => ({
    ...state,
    startInfoSearch: true,
    loadingInfoList: true,
    searchInfoType: action.payload.type,
    infoList: [],
  }),
  [APPLICATION_MODULE + SEARCH_INFO_BY_PARAM + SUCCESSFUL]: (state, action) => {
    const data = action.payload;
    return {
      ...state,
      loadingInfoList: false,
      infoList: data,
    };
  },
  [APPLICATION_MODULE + SEARCH_INFO_BY_PARAM + FAILED]: state => ({
    ...state,
    loadingInfoList: false,
  }),
  [APPLICATION_MODULE + SEARCH_INFO_BY_PARAM + CLEAR]: state => ({
    ...state,
    startInfoSearch: false,
    loadingInfoList: false,
    searchInfoType: null,
  }),
}, initialState);

export default reducer;

export const getApplicationData = createSelector(
  [state => state[APPLICATION_MODULE]],
  state => {
    const {
      listMeta,
      loadingList,
      list,
      loadingCurrentApplication,
      currentApplication,
      loadingApplicationStatus,
      applicationStatus,
      loadingSmevCheckList,
      smevCheckList,
      loadingAcceptApplication,
      loadingReturnApplication,
      loadingDeniedApplication,
      loadingSuspendedApplication,
      loadingAnnulmentApplication,
      loadingSmevCheckApplication,
      loadingApplicationHistory,
      applicationHistory,
      applicationHistoryMeta,
      loadingCreateApplication,
      loadingEditApplicationById,
      loadingReviewApplication,
      loadingFieldsValidation,
      fieldsValidation,
      awaitDocumentMeta,
      loadingLegalEntityFormList,
      legalEntityFormList,
      loadingIdList,
      listId,
      loadingExportApplication,
      loadingAcceptApplicant,
      loadingRegisterMaisEgu,
      maisEguHistoryList,
      loadingMaisEguHistory,
    } = state;
    return {
      maisEguHistoryList,
      loadingMaisEguHistory,
      awaitDocumentMeta,
      listMeta,
      loadingList,
      list,
      loadingCurrentApplication,
      currentApplication,
      loadingApplicationStatus,
      applicationStatus,
      loadingSmevCheckList,
      smevCheckList,
      loadingAcceptApplication,
      loadingReturnApplication,
      loadingDeniedApplication,
      loadingSuspendedApplication,
      loadingAnnulmentApplication,
      loadingSmevCheckApplication,
      loadingApplicationHistory,
      applicationHistory,
      applicationHistoryMeta,
      loadingCreateApplication,
      loadingEditApplicationById,
      loadingReviewApplication,
      loadingFieldsValidation,
      fieldsValidation,
      loadingLegalEntityFormList,
      legalEntityFormList,
      loadingIdList,
      listId,
      loadingExportApplication,
      loadingAcceptApplicant,
      loadingRegisterMaisEgu,
    };
  },
);

export const getAwaitDocumentData = createSelector(
  [state => state[APPLICATION_MODULE]],
  state => {
    const {
      awaitDocumentMeta,
      loadingAwaitDocument,
      awaitDocument,
      loadingDocument,
      currentDocument,
      loadingDeleteDocument,
      loadingGenerateDocx,
      loadingCurrentApplication,
      loadingReturnApplication,
      loadingDeniedApplication,
      loadingSuspendedApplication,
      loadingPreviewDocument,
    } = state;
    return {
      awaitDocumentMeta,
      loadingCurrentApplication,
      loadingReturnApplication,
      loadingDeniedApplication,
      loadingSuspendedApplication,
      loadingAwaitDocument,
      awaitDocument,
      loadingDocument,
      currentDocument,
      loadingDeleteDocument,
      loadingGenerateDocx,
      loadingPreviewDocument,
    };
  },
);

export const getInfoData = createSelector(
  [state => state[APPLICATION_MODULE]],
  state => {
    const {
      infoList,
      startInfoSearch,
      loadingInfoList,
      searchInfoType,
    } = state;
    return {
      infoList,
      startInfoSearch,
      loadingInfoList,
      searchInfoType,
    };
  },
);
